import { render } from "./WalletHeader.vue?vue&type=template&id=3e29619e&scoped=true"
import script from "./WalletHeader.vue?vue&type=script&lang=js"
export * from "./WalletHeader.vue?vue&type=script&lang=js"

import "./WalletHeader.vue?vue&type=style&index=0&id=3e29619e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e29619e"]])

export default __exports__